module.exports = __webpack_public_path__ + "static/media/user.0a665e3d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/display/modules/Home/PreviewPublic/Components/Icon/user.svg
// module id = 6971
// module chunks = 0